<template>
    <router-view />
</template>

<script setup lang="ts">
// This is the root component for the SPA
// It simply renders the current route's component
</script>
